export default __webpack_public_path__ + "static/media/product_09.d21d528b.jpg";